import React, {useState, useEffect} from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import ReactModal from "react-modal";

import "./ProblemThree.css";
import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import topicAreaIcon from "../../../../../resources/images/topic-area-icon.png";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {LeftLabelToggle} from "../../../../common/input/left-label-toggle/LeftLabelToggle";
import {CommentToolTip} from "../../../../common/tool-tip-comments/CommentToolTip";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";

export const ProblemThree = ({
                                 context,
                                 showToaster,
                                 setContext,
                                 navigateTo,
                                 navigateBack,
                                 setSpinnerText,
                                 toolTipsEnabled
                             }) => {

    ReactModal.setAppElement('#root');

    const [nextVisitDate, setNextVisitDate] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [baselines, setBaselines] = useState([]);
    const [baselineDateList, setBaselineDateList] = useState([]);
    const [baselineDate, setBaselineDate] = useState(null);
    const [baselineValue, setBaselineValue] = useState("");
    const [percentage, setPercentage] = useState(true);
    const [frequency, setFrequency] = useState({label: "Monthly", value: "Monthly"});
    const [frequencyOptions] = useState([
        {label: "Daily", value: "Daily"},
        {label: "Weekly", value: "Weekly"},
        {label: "Monthly", value: "Monthly"},
        {label: "Quarterly", value: "Quarterly"},
    ]);
    const [dateFormat, setDateFormat] = useState("MM/yyyy");
    const [showMonthPicker, setShowMonthPicker] = useState(true);
    const [numberOnlyRegExp] = useState(/^[0-9]*$/);
    const [showWarningModal, setShowWarningModal] = useState(false);

    useEffect(() => {
        if (context.problemScreen) {
            if (context.problemScreen.baselines) {
                setBaselines(context.problemScreen.baselines);
            }

            if (context.problemScreen.nextVisitDate) {
                setNextVisitDate(new Date(context.problemScreen.nextVisitDate));
            }

            if (context.problemScreen.frequency) {
                setFrequency(context.problemScreen.frequency);
                handleFrequencyChange(context.problemScreen.frequency)
            }
        }
    }, [context]);

    useEffect(() => {
        const baselineDateListToExclude = [];
        const copyOfBaselines = JSON.parse(JSON.stringify(baselines));
        if (frequency.label === "Quarterly") {
            copyOfBaselines.forEach((quarterlyBaseline) => {
                baselineDateListToExclude.push(addMonthsToDate(quarterlyBaseline.date, 0))
                baselineDateListToExclude.push(addMonthsToDate(quarterlyBaseline.date, 1))
                baselineDateListToExclude.push(addMonthsToDate(quarterlyBaseline.date, 2))
                baselineDateListToExclude.push(addMonthsToDate(quarterlyBaseline.date, -1))
                baselineDateListToExclude.push(addMonthsToDate(quarterlyBaseline.date, -2))
            });
        } else {
            copyOfBaselines.forEach((baseline) => {
                baselineDateListToExclude.push(new Date(baseline.date))
            });
        }
        setBaselineDateList(baselineDateListToExclude)
    }, [baselines]);

    const openOutcomeMeasureDataPointModal = () => {
        if (baselines.length > 0) {
            if (baselines[0].type === "Percentage") {
                setPercentage(true);
            } else {
                setPercentage(false);
            }
        }
        setShowModal(true);
    }

    const handleAddBaselineValuesClick = () => {
        let mappedBaselines;
        if (context.problemScreen.externalReference) {
            mappedBaselines = baselines.map((baseline, index) => {
                if (percentage) {
                    return {...baseline, type: "Percentage", listIndexId: index, isInitial: baseline.isInitial};
                } else {
                    return {...baseline, type: "Number", listIndexId: index, isInitial: baseline.isInitial};
                }
            });
        } else {
            mappedBaselines = baselines.map((baseline, index) => {
                if (percentage) {
                    return {...baseline, type: "Percentage", listIndexId: index, isInitial: true};
                } else {
                    return {...baseline, type: "Number", listIndexId: index, isInitial: true};
                }
            });
        }
        setBaselines(mappedBaselines);
        setShowModal(false);
        if (mappedBaselines.length < 6) {
            setShowWarningModal(true);
        }
    }

    const handleAddBaselineClick = () => {
        setBaselines((prevState) => ([
            ...prevState,
            {date: baselineDate, value: baselineValue}
        ]));
        setBaselineDate(null);
        setBaselineValue("");
    }

    const addMonthsToDate  = (date, months) => {
        const dateToUpdate = new Date(date);
        dateToUpdate.setMonth(dateToUpdate.getMonth() + +months);
        return dateToUpdate;
    }

    const handleFrequencyChange = (selectedFrequency) => {
        setFrequency(selectedFrequency)
        const {value} = selectedFrequency;
        if (value === "Monthly" || value === "Quarterly") {
            setDateFormat("MM/yyyy");
            setShowMonthPicker(true);
        } else {
            setDateFormat("dd/MM/yyyy");
            setShowMonthPicker(false);
        }
    }

    const handleNextClick = () => {
        setContext((prevState) => ({
            ...prevState,
            problemScreen: {
                ...prevState.problemScreen,
                baselines,
                nextVisitDate,
                frequency,
            }
        }));
        navigateTo("problemFour");
    }

    const handleDeleteBaselineClick = (index) => {
        const copyOfBaselines = [...baselines];
        copyOfBaselines.splice(index, 1);
        setBaselines([...copyOfBaselines]);
    }

    const handleValueChange = ({target}) => {
        let {value} = target;

        if (percentage) {
            value = value.slice(0, value.length - 1)
        }

        if (numberOnlyRegExp.test(value)) {
            setBaselineValue(value);
        }
    }

    const handleBaselineListItemDateChange = (date, index) => {
        const copyOfBaselines = JSON.parse(JSON.stringify(baselines));
        copyOfBaselines[index].date = date;
        setBaselines([...copyOfBaselines]);
    }

    const handleBaselineListItemValueChange = (value, index) => {
        const copyOfBaselines = JSON.parse(JSON.stringify(baselines));

        if (percentage) {
            value = value.slice(0, value.length - 1)
        }

        if (numberOnlyRegExp.test(value)) {
            copyOfBaselines[index].value = value;
            setBaselines([...copyOfBaselines]);
        }
    }

    const handleInputClick = ({target}) => {
        if (percentage) {
            const {value} = target;
            target.selectionStart = value.length - 1;
            target.selectionEnd = value.length - 1;
        }
    }

    const isMonday = (date) => {
        const day = new Date(date).getDay();
        return day === 1;
    };

    const baseLineListItems = baselines.map((baseline, index) => {
        return (
            <div className="problem-three-baseline-container" key={index}>
                <div className="problem-three-baseline-date-container">
                    <DatePicker selected={new Date(baseline.date)}
                                className="text-input"
                                dateFormat={dateFormat}
                                showPopperArrow={false}
                                showMonthYearPicker={showMonthPicker}
                                maxDate={new Date()}
                                disabled={!context.editMode}
                                excludeDates={baselineDateList}
                                filterDate={(frequency.value === "Weekly") ? isMonday : null}
                                popperPlacement="right"
                                onChange={(selectedDate) => {
                                    handleBaselineListItemDateChange(selectedDate, index);
                                }}/>
                </div>
                <div className="problem-three-baseline-value-container">
                    <input className="text-input"
                           value={baseline.value + (percentage ? "%" : "")}
                           onChange={({target}) => {
                               handleBaselineListItemValueChange(target.value, index);
                           }}
                           disabled={!context.editMode}
                           onClick={handleInputClick}/>
                </div>
                <button className="problem-three-baseline-delete-button"
                        onClick={() => {
                            handleDeleteBaselineClick(index)
                        }} disabled={baseline.isInitial}>
                    <FontAwesomeIcon className="problem-three-baseline-delete-icon"
                                     icon={faTimes}/>
                </button>
            </div>
        );
    });

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={topicAreaIcon} alt="Aurum Logo" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.topicAreaScreen.topicArea.topicArea}</p>
                </div>
                <div className="wizard-right-container">
                    <div>
                        <label className="label">Measure Frequency:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"prob3MeasureFrequency1"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Measure Frequency:"}/>}
                    </div>
                    <div className="problem-three-inline-select-container">
                        <p>To be measured on a</p>
                        <div className="problem-three-inline-select">
                            <Select options={frequencyOptions}
                                    onChange={handleFrequencyChange}
                                    value={{label: frequency.label, value: frequency.value}}
                                    classNamePrefix="select"
                                    isDisabled={!context.editMode}
                            />
                        </div>
                        <p>basis.</p>
                    </div>
                    <div>
                        <label className="label">Baselines:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"prob3Baselines2"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Baselines:"}/>}
                    </div>
                    <div className="problem-three-label-button-container">
                        <label>Outcome Measure:</label>
                        <StandardButton text="Data Point Values" onClick={openOutcomeMeasureDataPointModal}/>
                    </div>
                    <div className="input-container">
                        <label>Date Of Next Visit:</label>
                        <DatePicker selected={nextVisitDate}
                                    className="text-input"
                                    dateFormat="dd/MM/yyyy"
                                    showPopperArrow={false}
                                    disabled={!context.editMode}
                                    onChange={(selectedDate) => {
                                        setNextVisitDate(selectedDate)
                                    }}/>
                    </div>
                    {context.viewMode &&
                    <CommentToolTip contextName={"Problem"} showToaster={showToaster} setSpinnerText={setSpinnerText}
                                    contextExternalReference={context.problemToBeViewedExternalReference}
                                    context={context} toolTipsEnabled={toolTipsEnabled}/>}
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview"
                                        onClick={() => {
                                            navigateTo("problemTree");
                                        }}/>
                    </div>}
                    <div className="navigation-button-container">
                        <NextButton disabled={nextVisitDate === null || baselines.length < 6}
                                    onClick={handleNextClick}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>

            <ReactModal isOpen={showModal} className="modal-content" overlayClassName="modal-overlay">
                <div className={"label-div-tooltip-bl"}>
                    <label className="problem-three-modal-title">Baseline Values</label>
                    {toolTipsEnabled &&
                    <ToolTip tooltipExternalReference={"prob3Baselines23m"}
                             context={context}
                             setSpinnerText={setSpinnerText} showToaster={showToaster}
                             fieldName={"Baseline Values:"}/>}
                    <div className="problem-three-modal-toggle-container">
                        {context.editMode &&
                        <LeftLabelToggle labelText="Percentage:&nbsp;&nbsp;"
                                                               active={percentage}
                                                               setActive={setPercentage}/>}
                    </div>
                </div>
                <div className="problem-three-modal-content">
                    <div className="problem-three-modal-input-container">
                        <div className="problem-three-modal-input">
                            <label className="bold">Date:</label>
                            <DatePicker selected={baselineDate}
                                        showMonthYearPicker={showMonthPicker}
                                        maxDate={new Date()}
                                        className="text-input"
                                        dateFormat={dateFormat}
                                        showPopperArrow={false}
                                        disabled={!context.editMode}
                                        popperPlacement="right"
                                        popperModifiers={[]}
                                        excludeDates={baselineDateList}
                                        filterDate={(frequency.value === "Weekly") ? isMonday : null}
                                        onChange={(selectedDate) => {
                                            setBaselineDate(selectedDate);
                                        }}
                            />
                        </div>
                        <div className="problem-three-modal-input">
                            <label className="bold">Value:</label>
                            <input className="text-input"
                                   value={baselineValue + (percentage ? "%" : "")}
                                   onChange={handleValueChange}
                                   disabled={!context.editMode}
                                   onClick={handleInputClick}/>
                        </div>
                        <div className="problem-three-modal-add-button">
                            <StandardButton text="Add"
                                            onClick={handleAddBaselineClick}
                                            disabled={!baselineDate || !baselineValue}/>
                        </div>
                    </div>
                    <div className="baseline-list-items-container">
                        {baseLineListItems.reverse()}
                    </div>
                </div>
                {baselines.length < 6 &&
                <p className="problem-three-modal-text">Please add at least 6 baselines to calculate the median</p>}
                <div className="modal-button-container">
                    <StandardButton text="Update Baseline Values" onClick={handleAddBaselineValuesClick}/>
                </div>
            </ReactModal>

            <ReactModal isOpen={showWarningModal} className="modal-content" overlayClassName="modal-overlay">
                <div className="problem-three-warning-modal-content">
                    <p className="problem-three-warning-modal-text">
                        You must add at least 6 baseline values to proceed
                    </p>
                    <div className="modal-button-container">
                        <StandardButton text="Close" onClick={() => {
                            setShowWarningModal(false)
                        }}/>
                    </div>
                </div>
            </ReactModal>
        </div>
    );
}
